export default new class EtalonLineLink {
    constructor() {
        this.url = '';
        this.checkURLEtaloneLine();
    }

    checkURLEtaloneLine() {
        $('document').ready(function () {
            $('.article__main-container').on('click', function (e) {
              if (!(e.target).classList.contains('.like-btn')) {
                this.url = e.target.href ?? '';
                if (!$(e.target).hasClass('link') && this.url.match('etalonline\.by')) {
                  $.request('ArticlePage::onEtaloLine', {
                    data: {
                      url: this.url,
                    },
                    success: (response) => {
                      if (response.url !== undefined) {
                        window.open(response.url, '_blank');
                      }
                    }
                  });
                  return false;
                }
              }
            });
        });
    }
};
